import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import Common from '../module/Common';
import ManagerContext from '../context/ManagerContext';
import { ApiService } from '../services/ApiService';
import { BroadcastService } from '../services/BroadcastService';
import { DashboardService } from '../services/DashboardService';
import { MapPane } from '../components/MapPane';


export class MapPage extends Component {
    
    static displayName = MapPage.name;
    apiService = new ApiService();
    broadcastService = new BroadcastService();
    dashboardService = new DashboardService();


    constructor() {
        super();
        
        this.state = {
            activeJobs: [],
            driver: [],
            loadingActiveJobs: true, 
        };
    }


    componentDidMount() {
        setTimeout(() => {
            this.setState({ loadingActiveJobs: true });
            this.loadActiveJobs();
            this.loadActiveJobsWithInterval();
        })

        this.broadcastService.registerObserver('clientCodeOrStateSelected', () => {
            ApiService.activeJobs = [];
            this.setState({ loadingActiveJobs: true });
            this.loadActiveJobs();
        })
    }


    componentWillUnmount() {
        clearInterval(this.loadActiveJobsInterval);
        this.broadcastService.unregisterObserver('clientCodeOrStateSelected');
    }


    loadActiveJobs() {
        this.apiService.loadActiveJobs(this.context.SelectedStateId, this.context.SelectedClientCode)
        .then(activeJobs => {
            const drivers = this.dashboardService.getDriversFromActiveJobs(activeJobs);
            this.setState({ activeJobs: activeJobs, drivers: drivers });
        })
        .finally(() => {
            this.setState({ loadingActiveJobs: false });
        });
    }


    loadActiveJobsWithInterval() {
        this.loadActiveJobsInterval = setInterval(() => {
            ApiService.activeJobs = []; /* Clear first the cached activeJobs data */
            this.loadActiveJobs();
        }, Common.getRefreshTime());
    }
    

    render() {
        let context = this.context;

        if (context.IsLoggedIn()) {
            return (
                <Container fluid>
                    <Row xs="1" >
                        <Col style={{height:'75vh'}}>
                            <MapPane 
                                drivers={this.state?.drivers}
                                hideLegendContainer={true}
                            ></MapPane>
                        </Col>
                    </Row>
                </Container>
            );
        } else {
            return (
                <Container fluid>
                    <p>Please ensure you have logged in</p>
                </Container>
                );
        }

    }
}

MapPage.contextType = ManagerContext;
